/* eslint-disable */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CloudUploadSharpIcon from '@mui/icons-material/CloudUploadSharp';
import Theme from '../ui/Theme'; // Ensure Theme is correctly set up

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: 'none',
  },
  btnStyle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '15px',
    display: 'flex',
    alignItems: 'center',
    color: Theme.palette.primary.main,
  },
}));

export default function CustomFileUploadButton({
  name,
  id,
  handleUpload,
  styles,
  disabled = false,
  acceptedFileTypes = '.csv',
}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <input
        name={name}
        accept={acceptedFileTypes}
        className={classes.input}
        id={id ?? 'upload-file'}
        multiple
        onChange={handleUpload}
        type="file"
        disabled={disabled}
      />
      <label htmlFor={id ?? 'upload-file'}>
        <Button
          startIcon={<CloudUploadSharpIcon />}
          variant="contained"
          style={styles}
          disableElevation
          component="span"
          disabled={disabled}
        >
          <div className={classes.btnStyle}>Upload</div>
        </Button>
      </label>
    </div>
  );
}
